import { Navigate } from 'react-router-dom';
import LoginStateManager from '../core/LoginStateManager';

const Home = () => {
    if (!LoginStateManager.isLoggedIn()) {
        return <Navigate to={'/login'} />;
    }
    return <Navigate to={'/dashboard'} />;
};

export default Home;
